export enum CustomerType {
  Home = 'home',
  Business = 'business',
}
export const HouseholdConsumptionBrackets = [
  { consumption: 1927, size: '1' },
  { consumption: 3095, size: '2' },
  { consumption: 4255, size: '3' },
  { consumption: 4725, size: '4' },
  { consumption: 5194, size: '5+' },
];

export const BusinessConsumptionBrackets = [
  { consumption: 10000, size: 'small' },
  { consumption: 25000, size: 'medium' },
  { consumption: 50000, size: 'large' },
];

export const CustomerTypeDefaults = {
  [CustomerType.Home]: HouseholdConsumptionBrackets[1],
  [CustomerType.Business]: BusinessConsumptionBrackets[2],
};

export function getSize(
  energyConsumption: number,
  customerType: CustomerType
): string {
  const consumptionBrackets =
    customerType == CustomerType.Business
      ? BusinessConsumptionBrackets
      : HouseholdConsumptionBrackets;
  return consumptionBrackets.reduce((closestBracket, bracket) => {
    const currentDiff = Math.abs(bracket.consumption - energyConsumption);
    const closestDiff = Math.abs(
      closestBracket.consumption - energyConsumption
    );
    return currentDiff < closestDiff ? bracket : closestBracket;
  }).size;
}
